export enum DeliveryFeedType {
  DELIVERY_PACKAGE = 'delivery_package',
  COMMENT = 'comment',
  ACTIVITY = 'activity',
}
